module.exports = __webpack_public_path__ + "img/1f9e3.2c5c3b7.svg";